export const SUPPORTED_LANGUAGES = ['fr', 'en'] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = 'fr';

/** Choix de l'utilisateur, prioritaire sur la langue du navigateur lors des visites suivantes. */
export const LANGUAGE_STORAGE_KEY = 'foundit.language';

/** Nom de chaque langue dans sa propre langue : un sélecteur ne traduit jamais ces libellés. */
export const LANGUAGE_NATIVE_NAMES: Record<Language, string> = {
    fr: 'Français',
    en: 'English',
};

/** Format attendu par Open Graph (og:locale). */
export const OPEN_GRAPH_LOCALES: Record<Language, string> = {
    fr: 'fr_FR',
    en: 'en_US',
};

export const isSupportedLanguage = (value: unknown): value is Language =>
    SUPPORTED_LANGUAGES.includes(value as Language);
